import Vue from 'vue'
import Vuex from 'vuex'
import { localSave, localRead } from '@/utils/tools'
import { checkLogin } from '@/api/user'
import { saveRouterLabel, changeMenu, saveButtonControls } from '@/store/modules/user'

/*储存IM用户信息*/
function saveLocalInfoIM(result) {
  const isBy = result.isBy
  const { displayName, imageAddress, status, userName, companyId, email, phone, userToken, businessIdCompany, businessIdUser, top, language, id } = result.userVo
  let userInfo = {
    displayName,
    imageAddress,
    status,
    userName,
    companyId,
    email,
    phone,
    userToken,
    businessIdCompany,
    businessIdUser,
    top,
    id,
    language,
    isBy: isBy
  }
  localSave('sys_userInfo_IM', JSON.stringify(userInfo))
}

const state = {
  webSockets: {},
  chatData: {},//用户聊天消息
  advanceChatData: {},//用户预输入聊天消息
  chatDataSingle: [],//人工客服私聊聊天消息
  chatDataPublic: [],//人工客服公聊聊天消息
  chatList: [],//会话列表
  intelligentChatList: [],//智能客服会话列表
  messageNums: {},//人工客服未读消息数量
  singleMessageNums: {},//客服私聊未读消息数量
  sessionId: {},//当前人工客服会话sessionId
  intelligentSessionId: '',//当前智能客服会话sessionId
  singleUserToken: '',//私聊人工客服userToken
  acceptSessionId: {},//人工客服接受会话sessionId
  monitorSessionId: {},//监控人工客服会话列表sessionId
  sessionStatus: '',//当前客户是否在线
  serviceMark: '',//人工客服红点标记
  serviceStatus: '',//人工客服状态
  monitorChat: {},//监控人工客服信息
  checkedData: []
}

const mutations = {
  SETWEBSOCKET(state, webSocket) {
    state.webSockets = webSocket
  },
  SETCHATDATA(state, chatData) {
    state.chatData = chatData
  },
  SETADVANCECHATDATA(state, advanceChatData) {
    state.advanceChatData = advanceChatData
  },
  SETCHATDATASINGLE(state, chatDataSingle) {
    state.chatDataSingle = chatDataSingle
  },
  SETCHATDATAPUBLIC(state, chatDataPublic) {
    state.chatDataPublic = chatDataPublic
  },
  SETCHATLIST(state, chatList) {
    state.chatList = chatList
  },
  SETINTELLIGENTCHATLIST(state, intelligentChatList) {
    state.intelligentChatList = intelligentChatList
  },
  SETMESSAGENUMS(state, messageNums) {
    state.messageNums = messageNums
  },
  SETSINGLEMESSAGENUMS(state, singleMessageNums) {
    state.singleMessageNums = singleMessageNums
  },
  SETSESSIONID(state, sessionId) {
    state.sessionId = sessionId
  },
  SETINTELLIGENTSESSIONID(state, intelligentSessionId) {
    state.intelligentSessionId = intelligentSessionId
  },
  SETSINGLEUSERTOKEB(state, singleUserToken) {
    state.singleUserToken = singleUserToken
  },
  SETACCEPTSESSIONID(state, acceptSessionId) {
    state.acceptSessionId = acceptSessionId
  },
  SETMONITORSESSIONID(state, monitorSessionId) {
    state.monitorSessionId = monitorSessionId
  },
  SETSESSIONSTATUS(state, sessionStatus) {
    state.sessionStatus = sessionStatus
  },
  SETSERVICEMARK(state, serviceMark) {
    state.serviceMark = serviceMark
  },
  SETSERVICESTATUS(state, serviceStatus) {
    state.serviceStatus = serviceStatus
  },
  SETMONITORCHAT(state, monitorChat) {
    state.monitorChat = monitorChat
  },
  SETCHECKEDDATA(state, checkedData) {
    state.checkedData = checkedData
  }
}

const actions = {
  setUserInfoIM({ commit }, model) {
    return new Promise((resolve, reject) => {
      let codeArr = JSON.parse(localRead('sysCode'))
      checkLogin({ model: model }).then(response => {
        const { result } = response
        // 存储全局的系统标识
        saveLocalInfoIM(result)
        if (localRead('model') != -1) {
          if (codeArr[0].code == 'IM') {
            // 存储全局的系统标识
            saveRouterLabel(result, result.model)
            //调菜单获取菜单添加路由
            changeMenu(result.code)
            //存储按钮权限
            saveButtonControls()
          }
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  setWebSocket({ commit }, view) {
    commit('SETWEBSOCKET', view)
  },
  setChatData({ commit }, view) {
    commit('SETCHATDATA', view)
  },
  setAdvanceChatData({ commit }, view) {
    commit('SETADVANCECHATDATA', view)
  },
  setChatDataSingle({ commit }, view) {
    commit('SETCHATDATASINGLE', view)
  },
  setChatDataPublic({ commit }, view) {
    commit('SETCHATDATAPUBLIC', view)
  },
  setChatList({ commit }, view) {
    commit('SETCHATLIST', view)
  },
  setIntelligentChatList({ commit }, view) {
    commit('SETINTELLIGENTCHATLIST', view)
  },
  setMessageNums({ commit }, view) {
    commit('SETMESSAGENUMS', view)
  },
  setSingleMessageNums({ commit }, view) {
    commit('SETSINGLEMESSAGENUMS', view)
  },
  setSessionId({ commit }, view) {
    commit('SETSESSIONID', view)
  },
  setIntelligentSessionId({ commit }, view) {
    commit('SETINTELLIGENTSESSIONID', view)
  },
  setSingleUserToken({ commit }, view) {
    commit('SETSINGLEUSERTOKEB', view)
  },
  setAcceptSessionId({ commit }, view) {
    commit('SETACCEPTSESSIONID', view)
  },
  setMonitorSessionId({ commit }, view) {
    commit('SETMONITORSESSIONID', view)
  },
  setSessionStatus({ commit }, view) {
    commit('SETSESSIONSTATUS', view)
  },
  setServiceMark({ commit }, view) {
    commit('SETSERVICEMARK', view)
  },
  setServiceStatus({ commit }, view) {
    commit('SETSERVICESTATUS', view)
  },
  setMonitorChat({ commit }, view) {
    commit('SETMONITORCHAT', view)
  },
  setCheckedData({ commit }, view) {
    commit('SETCHECKEDDATA', view)
  }
}

Vue.use(Vuex)
export default new Vuex.Store({
  namespaced: true,
  state,
  mutations,
  actions
})

